export default "__VITE_ASSET__c4177577__"